import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, Options} from "../utils/decorators";
import 'slick-carousel';


@Options({
    template: false
})
export default class GalleryView extends Marionette.View<Backbone.Model>{

    config?: object;

    constructor(options?:object, config?:object) {
        super(options);
        this.config = config || {};
    }

    onRender() {
        this.renderGallery(this.$el);
    }

    renderGallery($el:JQuery) {
        if(window.CMS && window.CMS.config && window.CMS.config.mode == "draft") {
            return;
        }

        const config = this.config;
        window.setTimeout(() => {
            ($el as any).slick(config);
        }, 0);

        ($el as any).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            let isInverted = $(`[data-slick-index="${nextSlide}"]`, $el).hasClass('gallery__item--inverted');
            $el.closest('.hero').toggleClass('hero--inverted', isInverted);
            $('body').toggleClass('use-inverted-header', isInverted);
        });
    }
}



// WEBPACK FOOTER //
// ./@modules/views/gallery-view.ts